'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.setup = setup;
exports.unwrapStream = unwrapStream;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _camelCaseObject = require('./camelCaseObject');

var _camelCaseObject2 = _interopRequireDefault(_camelCaseObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: commenting these retry bits out for now; will bring it back once we have stream retries
// again
// import setupRetry from './setupRetry';

// let retryLimit;
var timeout = void 0;

function setup(timeoutConfig) {
  // retryLimit = retryLimitConfig;
  timeout = timeoutConfig;
}

function unwrapStream(url) {
  var now = Date.now();

  return (0, _axios2.default)({
    url: url,
    transformResponse: [].concat((0, _toConsumableArray3.default)(_axios2.default.defaults.transformResponse), [_camelCaseObject2.default]),
    timeout: timeout
  }).catch(function (err) {
    err.errorData = {
      duration: Date.now() - now
    };

    throw err;
  });

  // return setupRetry(unwrapCallback, retryLimit);
}
//# sourceMappingURL=streamUnwrap.js.map